<!-- ***Designed by Rahul Kumar***** -->

<!-- Hello simple dropdown -->

<div *ngIf = "showSavedFilter === false" class = "savedSearchFilter">
    No Searches Saved
</div>
<div title="{{fieldControl.value?.displayValue || configData.placeHolder | translate}}">
    <div *ngIf="showSavedFilter !== false" class="dhl-form-field-simple-dropdown-v2" [formGroup]="frmGroup" [class.disabled]="disabled || frmGroup.get(configData.name).disabled"
        [hidden]="frmGroup.get(configData.name)['hidden']  || ( configData.UoMkey && configData?.UoMkey !== PreferredUom)" tabindex="{{disabled ? '-1': '0'}}">
        <!-- CP-3724: Add new class for predefined query dropdown by using product type QUERY_FILTER and apply css according to that  -->
        <div class="form-field-wrapper" [class.disabled]="disabled || frmGroup.get(configData.name).disabled"
            [ngClass]="{'filter-display': configData['productType'] === 'QUERY_FILTER' }">

            <label class="filter-label" *ngIf="configData['productType'] === 'QUERY_FILTER' ">{{configData.label}}:</label>
            <div class="form-field-control" #formControl
                (click)="toggleDropdownList($event.target)" [ngClass]="{'error': (frmGroup.get(configData.name).errors && frmGroup.get(configData.name).touched && !frmGroup.get(configData.name).valid),
                'filter-space': configData['productType'] === 'QUERY_FILTER'}">

                <select [formControl]="frmGroup.get(configData.name)" hidden [formControlName]="configData.name"
                    class="hidden-form-control" [required]="configData.required">
                    <option [value]=""></option>
                    <option *ngFor="let option of listOptions" [value]="option">
                        {{option.displayValue | translate}}</option>
                </select>

                <div #visibleFormControl class="visible-form-control"
                    [ngClass]="{'active': fieldControl.value || (configData.placeHolder && configData['productType'] === 'NEW_FILTER'), 'new-filter-control': configData['productType'] === 'NEW_FILTER', 'warning': infoMsg?.warning}" *ngIf="configData['productType'] !== 'QUERY_FILTER'">
                    <div class="control-content" [class.hide-second-span]="!configData?.tooltip?.icon">
                        <span class="form-field-label">
                            <label class="base-label">
                                {{configData?.label | translate}}<span *ngIf="configData?.required || this.frmGroup.get(this.configData.name)['required']"> *</span>
                            </label>
                            <span *ngIf="fieldControl.value" class="form-field-value">
                                {{fieldControl.value.displayValue | translate}}
                            </span>
                            <span *ngIf="!fieldControl.value && configData['productType'] === 'NEW_FILTER'" class="form-field-value placeHolder">
                                {{configData.placeHolder || 'Please select...'}}
                            </span>
                        </span>
                        <span class="dropdown-icons" *ngIf="configData?.tooltip?.icon">
                            <span class="tt" [ngClass]="{'show': toggleList || fieldControl.value, 'filled-icon': fieldControl.value}">
                                <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2260,24,24))" style="width:20px;height:20px" type="image/svg+xml" />
                                <span class="tt-text">{{configData?.tooltip?.message}}</span>
                            </span>
                        </span>
                        <span class="dropdown-icons">
                            <span class="disabled-icon" hidden>
                                <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1442,20,20))"
                                    style="width:20px;height:20px" type="image/svg+xml" />
                            </span>
                            <span [ngClass]="{'show': toggleList}" class="active-icon">
                                <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,120,24,24))"
                                    style="width:20px;height:20px" type="image/svg+xml" />
                            </span>
                            <span [ngClass]="{'hide': (toggleList || fieldControl.value)}" class="normal-icon">
                                <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,90,24,24))"
                                    style="width:20px;height:20px" type="image/svg+xml" />
                            </span>
                            <span [ngClass]="{'show': fieldControl.value || configData['productType'] === 'NEW_FILTER', 'open': toggleList}" class="filled-icon">
                                <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,180,24,24))"
                                    style="width:20px;height:20px" type="image/svg+xml" />
                            </span>
                        </span>
                    </div>
                </div>
                <div #visibleFormControl class="visible-form-control filter-height"
                [ngClass]="{'filter-control': configData['productType'] === 'QUERY_FILTER', 'focus': toggleList, 'active': fieldControl.value}"
                    title="{{fieldControl.value?.displayValue || configData.placeHolder}}"
                    *ngIf="configData['productType'] === 'QUERY_FILTER'">
                    <div class="control-content">
                        <span class="form-field-label form-filter-label">
                            <span *ngIf="fieldControl.value" class="form-field-value filter-value">
                                {{fieldControl.value.displayValue | translate}}
                            </span>
                        </span>
                    </div>
                </div>
                <span class="default-icon" *ngIf="configData['productType'] === 'QUERY_FILTER'"
                    [ngClass]="{'filter-active-icon': toggleList}">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,210,24,24))"
                        style="width:24px;height:24px" type="image/svg+xml" />
                </span>
                <div #visibleDropdownList class="visible-dropdown-list"
                    [ngClass]="{'hide-border': !toggleList, 'hide': !toggleList, 'new-filter-list': configData['productType'] === 'NEW_FILTER'}">
                    <ng-container>
                        <div title="{{option.displayValue}}" *ngFor="let option of listOptions"
                            class="visible-dropdown-item" [ngClass]="{'disable-option': option.disabled}" (click)="selectedOption(option, $event)"
                            [class.hidden-option]="option.hideOption"> 
                            {{option.displayValue | translate}}
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="form-field-warning" *ngIf="infoMsg?.warning && !frmGroup.get(configData.name).errors">
                <span class="warning-icon">
                    <img class="dhl-input-warning-icon"
                        src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2240,24,24))">
                </span>
                <span class="warning-text">
                    <span>{{infoMsg.message.configDataLabel | translate}}</span>
                </span>
            </div>
            <div class="form-field-warning" *ngIf="configData?.warningMessage && !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched ||frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)">
                <span class="warning-icon"> 
                    <img class="dhl-input-warning-icon"
                        src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2240,24,24))">
                </span>
                <span class="warning-text">
                    <span>{{configData?.warningMessage}}</span>
                </span>
            </div>
            <div class="form-field-error"
                [ngClass]="{'hide-error': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched || frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
                <span class="error-icon">
                    <img class="dhl-input-error-icon"
                        src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
                </span>

                <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                    <span *ngIf="frmGroup.get(configData.name).errors.required">Required</span>
                    <span *ngIf="frmGroup.get(configData.name).errors.onValueSelection">{{frmGroup.get(configData.name).errors.onValueSelection.message}}</span>
                    <span *ngIf="frmGroup.get(configData.name).errors?.groupValidationError">
                        {{ frmGroup.get(configData.name).errors?.groupValidationError | translate }}
                    </span>
                </span>
            </div>
        </div>
    </div>
</div>
<div *ngIf="configData['filterType'] == 'savedSearchFilter' && showDeleteFilterButton" class="btn-content-lable">
    <button class="button-label btn" (click)="deleteSearch($event)">
        <img class="icon-bin" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2800,24,24))">
        {{configData?.buttonLabel}}
    </button>
</div>
